<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Audit Data Loading...
  </div>

  <div v-else class="animated fadeIn">
    <basic-heading title="Audit Trail" class="mb-3">
      <template #right-content>
        <header-button-group :button_config="button_config">
        </header-button-group>
      </template>
    </basic-heading>

    <permission-alert-gate :permissions="'read analyte'">
      <template #gated-content>
        <analyte-card :analyte="analyte" />

        <div>
          <h3>
            Change Log
            <b-button class="float-right" variant="success" :to="`/analytes/${analyte_id}/audit-trail-history`">
              View History
            </b-button>
          </h3>
        </div>
        <AuditChangeLogTable
          :model="analyte"
        />

        <h3>Relations</h3>
        <AuditRelationTable
          :model="analyte"
        />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import ToastNotifications from '@/components/shared/mixins/ToastNotifications'
import PermissionAlertGate from "@/components/permission/PermissionAlertGate"
import AnalyteCard from '@/components/lab/analyte/AnalyteCard'
import AuditChangeLogTable from '@/components/shared/audit/AuditChangeLogTable'
import AuditRelationTable from '@/components/shared/audit/AuditRelationTable'
import BasicHeading from '@/components/shared/BasicHeading'
import HeaderButtonGroup from '@/components/shared/headerbuttons/HeaderButtonGroup'
import AnalyteModel from '@/models/lab/AnalyteModel'

export default {
  name: "AnalyteAuditTrail",
  components: {
    PermissionAlertGate,
    AnalyteCard,
    AuditChangeLogTable,
    AuditRelationTable,
    BasicHeading,
    HeaderButtonGroup
  },
  mixins: [ToastNotifications],
  data () {
    return {
      loading: true,
      analyte: null,
      analyte_id: this.$route.params.analyte_id || null
    };
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-eye",
            linkto: `/analytes/${this.analyte_id}`,
            title: "View analyte",
            variant: "info",
          }
        ]
      }
    },
  },
  async created () {
    this.loading = true

    this.analyte = new AnalyteModel({ id: this.analyte_id })

    const params = {}
    params.connection = ['auditCreatedBy', 'auditUpdatedBy']

    this.analyte.fetch({ params }).then(() => {
      this.loading = false
    })
  },
}
</script>
